import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "confirmInput", "deleteButton"]

  connect() {
    console.log("Delete account controller connected")
  }

  showConfirmation(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    // Reset input and button state
    this.confirmInputTarget.value = ""
    this.validateInput()
  }

  closeModal(event) {
    event.preventDefault()
    this.modalTarget.classList.add("hidden")
    // Reset input
    this.confirmInputTarget.value = ""
    this.validateInput()
  }

  validateInput() {
    const input = this.confirmInputTarget.value.trim()
    const expectedValue = this.confirmInputTarget.dataset.expectedValue
    const isValid = input === expectedValue

    if (isValid) {
      this.deleteButtonTarget.classList.remove("opacity-50", "pointer-events-none")
      this.deleteButtonTarget.disabled = false
    } else {
      this.deleteButtonTarget.classList.add("opacity-50", "pointer-events-none")
      this.deleteButtonTarget.disabled = true
    }
  }
}
